"use strict";
/****************************************************
 * Audit Information Platform Component
 * 无参照情况下的检索头部
 * 2020-08
 * Sunny <tufpsj@yonyou.com>
 ****************************************************/
Object.defineProperty(exports, "__esModule", { value: true });
//----- Global ------
var React = require("react");
//----- iUAP ------
var tinper_bee_1 = require("tinper-bee");
var utils_1 = require("../utils");
/**
 * 没有参照的显示框
 * @param {NoRefSearchProp} props
 */
var NoRefSearch = function (props) {
    return (React.createElement("div", { className: "aip-no-search-bar" },
        React.createElement(tinper_bee_1.Button, { className: "aip-search-submit-btn", size: "sm", colors: "primary", onClick: props.doSearch },
            React.createElement(tinper_bee_1.Icon, { type: "uf-search" }),
            (0, utils_1.getTranslate)(null, props.searchBtnText || "查询"))));
};
exports.default = NoRefSearch;
